import { FC, useEffect, useRef, useState } from 'react';
import { Box, Button, TextField, Typography, styled } from '@mui/material';

const InfoCardLabel = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Prompt',
    fontStyle: 'normal',
    fontWeight: '600',
    cursor: 'pointer',
    textWrap: 'wrap',
    color: 'white',
    // overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    [theme.breakpoints.up('xs')]: {
      fontSize: '16px',
      lineHeight: '18px',
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '18px',
      lineHeight: '18px',
      textAlign: 'center',
    },
  }));  
  const ValueTitle = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Prompt',
    fontStyle: 'normal',
    fontWeight: '400',
    // width: '100%',
    // cursor: 'pointer',
      // textAlign: 'center',
    // textWrap: 'wrap',
    color: 'white',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    [theme.breakpoints.up('xs')]: {
      fontSize: '12px',
      lineHeight: '18px',
      img: {
        display: 'none',
      },
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '14px',
      lineHeight: '18px',
      img: {
        display: 'block',
      },
    },
  }));
interface PoolCardProps {
}

const InfoSection: FC<PoolCardProps> = ({  }) => {
    const [name, setName] = useState<string>('');
    const [symbol, setSymbol] = useState<string>('');
    const [isCheckErrors, setCheckErrors] = useState(false);

    const onChangeName = (e: any) => {
        const newAmount = e.target.value;
        setName(newAmount);
    };
      const onChangeSymbol = (e: any) => {
        const newAmount = e.target.value;
        setSymbol(newAmount);
    };

  return (
    <>
        <Box display='flex' flexDirection='column' justifyContent='center' sx={{border: '0px solid blue'}}>
            <Box mt={1} display='flex' flexDirection='column' sx={{
                    border: '1px solid #1B1E29',
                    backgroundColor: 'rgba(0.6, 0.6, 0.1,0.3)',
                    padding: '10px',
                    width: '100%',
                    borderRadius: '10px',
                    height: '100%',
                alignItems: 'center',
                    }}>
                  <ValueTitle>
                  IMPORTANT INFO FOR Staking Pool CREATORS
                 </ValueTitle>
                <ValueTitle mt={1}>
Staking is immutable and cannot be changed after it's deployment. Rewards sent to newly created Staking Pool are not recoverable.
                </ValueTitle>
                 <ValueTitle mt={1}>
                Fees: 2% from Rewards will be sent to Based Labs Treasury.
                 </ValueTitle>
            </Box>
        </Box>
    </>
  );
};

export default InfoSection;
